import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; 
import './ContactButton.css';

interface ContactButtonProps {
  to?: string;        // URL personalizada opcional
  children?: React.ReactNode; // Para permitir cambiar el texto si fuera necesario
}

const ContactButton: React.FC<ContactButtonProps> = ({ to, children }) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language.split('-')[0];

  // Definimos la ruta por defecto si no se recibe la prop 'to'
  const targetPath = to || `/${currentLang}/contacto`;

  // Verificamos si es un enlace externo o especial (mailto, tel, http)
  const isExternal = targetPath.startsWith('mailto:') || 
                     targetPath.startsWith('tel:') || 
                     targetPath.startsWith('http');

  const content = children || t('buttons:contactUs');

  if (isExternal) {
    return (
      <a href={targetPath} className="contact-btn">
        {content}
      </a>
    );
  }

  return (
    <Link to={targetPath} className="contact-btn">
      {content}
    </Link>
  );
};

export default ContactButton;